export const host = "https://vsocial-backend.up.railway.app"
// export const host = "https://vsocial-backend.up.railway.app"